import React from 'react'
import {ReactComponent as ThumbsUpDownIcon} from '../../Icons/Union.svg';
import {ReactComponent as ArrowUpIcon} from '../../Icons/thumbsUp.svg';
import {ReactComponent as ArrowDownIcon} from '../../Icons/thumbDown.svg';
import {ReactComponent as ArrowDownSelectedIcon} from '../../Icons/thumbsdownSelected.svg';
import {ReactComponent as ArrowUpSelectedIcon} from '../../Icons/thumbsUpSelected.svg';
import {ReactComponent as ThumbsUpDownTrueIcon} from '../../Icons/UnionTrue.svg';
import {ReactComponent as ThumbsUpDownFalseIcon} from '../../Icons/UnionFalse.svg';

import TooltipComp from '../ToolTip/TooltipComp';
export default function Voting({onClickFunc, value}) {

    const variable = ()=>{
        return(
            <span style={{display:'flex', alignItems:'center', cursor:'pointer'}}>{value===0?<ArrowDownSelectedIcon  />:<ArrowDownIcon onClick={()=>onClickFunc(0)} />}&nbsp;&nbsp;{value===1?<ArrowUpSelectedIcon  />:<ArrowUpIcon onClick={()=>onClickFunc(1)} />}</span>
        )
    }
  return (
    <>
    <TooltipComp title={variable()}>
        {value===null ? <ThumbsUpDownIcon/>:value?<ThumbsUpDownTrueIcon/>:<ThumbsUpDownFalseIcon/>}
    </TooltipComp>
    </>
  )
}
